import {
    TIMER_INTERVAL_UNIT,
    TIMER_TRIGGER_MODE,
    type TimerEventConfig,
    type TimerIntervalPreset
} from '@lighthouse/core'

export const TIMER_INTERVAL_PRESET_MS: Record<Exclude<TimerIntervalPreset, 'CUSTOM'>, number> = {
    '1s': 1000,
    '3s': 3000,
    '5s': 5000,
    '10s': 10000,
    '30s': 30000,
    '1m': 60_000,
    '5m': 5 * 60_000,
    '10m': 10 * 60_000,
    '30m': 30 * 60_000
}

export const TIMER_INTERVAL_PRESET_OPTIONS: { label: string; value: TimerIntervalPreset }[] = [
    { label: '1秒', value: '1s' },
    { label: '3秒', value: '3s' },
    { label: '5秒', value: '5s' },
    { label: '10秒', value: '10s' },
    { label: '30秒', value: '30s' },
    { label: '1分钟', value: '1m' },
    { label: '5分钟', value: '5m' },
    { label: '10分钟', value: '10m' },
    { label: '30分钟', value: '30m' },
    { label: '自定义', value: 'CUSTOM' }
]

export const TIMER_INTERVAL_UNIT_OPTIONS: { label: string; value: TIMER_INTERVAL_UNIT }[] = [
    { label: '秒', value: TIMER_INTERVAL_UNIT.SECOND },
    { label: '分钟', value: TIMER_INTERVAL_UNIT.MINUTE }
]

export const TIMER_TRIGGER_MODE_OPTIONS: { label: string; value: TIMER_TRIGGER_MODE }[] = [
    { label: '1次', value: TIMER_TRIGGER_MODE.ONCE },
    { label: '重复', value: TIMER_TRIGGER_MODE.REPEAT }
]

const formatDurationLabel = (ms: number) => {
    if (ms % 60_000 === 0) {
        return `${ms / 60_000}分钟`
    }
    if (ms % 1000 === 0) {
        return `${ms / 1000}秒`
    }
    return `${ms}毫秒`
}

export const resolveTimerIntervalMs = (config?: TimerEventConfig): number => {
    if (!config) {
        return 0
    }

    if (config.intervalPreset === 'CUSTOM') {
        const value = config.customInterval
        if (value === undefined || value === null || !Number.isFinite(value) || value <= 0) {
            return 0
        }
        const unit = config.customIntervalUnit ?? TIMER_INTERVAL_UNIT.SECOND
        return unit === TIMER_INTERVAL_UNIT.MINUTE ? value * 60_000 : value * 1000
    }

    return TIMER_INTERVAL_PRESET_MS[config.intervalPreset] ?? 0
}

export const formatTimerEventLabel = (config?: TimerEventConfig): string => {
    const ms = resolveTimerIntervalMs(config)
    const duration = ms > 0 ? formatDurationLabel(ms) : '未设置'
    const isRepeat = config?.triggerMode === TIMER_TRIGGER_MODE.REPEAT
    return isRepeat ? `定时器 · 每${duration}` : `定时器 · ${duration}后`
}
